import {
    addCommonFailTracker,
    addCommonFinishTracker,
    addCommonStartTracker,
} from '@/utils/vuex-common/addCommonRequestTracker';

// The migrated Pinia stores expose the legacy start/finish/fail mutations as
// same-named actions; $onAction replaces the old app.observer.onMutation hooks.
export function observeTrackAndLogOnStore(
    app: any,
    store: { $onAction: (cb: (context: { name: string, args: any[] }) => void) => void },
    actionsToObserve: { start?: string, finish?: string, fail?: string },
    text: { module: string, title: string, action: string },
): void {
    const { module, title, action } = text;
    store.$onAction(({ name, args }) => {
        const rpName = args?.[0]?.rpName || null;
        if (name === actionsToObserve.start) {
            addCommonStartTracker(app, rpName, module, title, action);
        } else if (name === actionsToObserve.finish) {
            addCommonFinishTracker(app, rpName, module, title, action);
        } else if (name === actionsToObserve.fail) {
            addCommonFailTracker(app, rpName, module, title, action);
        }
    });
}
